<template>
  <div v-if="showNotice" class="cookie-notice">
    <p>Tämä sivusto käyttää välttämättömiä evästeitä kirjautumisen ylläpitämiseksi.</p>
    <button @click="acceptCookies">OK</button>
  </div>
</template>

<script>
export default {
  name: 'CookieNotice',
  data() {
    return {
      showNotice: false
    }
  },
  mounted() {
    // Check if user has already accepted cookies
    this.showNotice = !localStorage.getItem('cookiesAccepted');
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.showNotice = false;
    }
  }
}
</script>

<style scoped>
.cookie-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  font-size: 0.9rem;
}

.cookie-notice button {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 1rem;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .cookie-notice {
    flex-direction: column;
    padding: 0.5rem;
  }
  
  .cookie-notice button {
    margin-top: 0.5rem;
    margin-left: 0;
    width: 100%;
  }
}
</style>